<template>
  <div>
    <v-form>
      <v-text-field
        v-if="context !== 'create'"
        v-model="localReport.name"
        :label="$tc('name')"
        :error-messages="nameErrors"
        prepend-inner-icon="mdi-form-textbox"/>
      <vf-autocomplete
        v-model="reportCustomers"
        :items="availableCustomers"
        :error-messages="customerErrors"
        :label="$tc('customer', 2)"
        all/>
      <v-row>
        <v-col>
          <div class="d-flex align-center">
            <date-picker
              v-model="startDate"
              :timezone="timezone"
              :output-moment="true"
              :label="$t('start_date')"
              prepend-inner-icon="mdi-calendar"
              :error-messages="dateRangeErrors"/>
            <span class="text-subtitle-1 mx-2">{{ $t('to') }}</span>
            <date-picker
              v-model="endDate"
              :timezone="timezone"
              :output-moment="true"
              :end-of-day="true"
              :label="$t('end_date')"
              prepend-inner-icon="mdi-calendar"
              :error="dateRangeErrors.length > 0"/>
          </div>
        </v-col>
      </v-row>
      <date-selector-shortcuts :lowerBound.sync="startDate" :upperBound.sync="endDate" :timezone="timezone"/>
    </v-form>
  </div>

</template>

<script>
import DatePicker from '@/components/shared/DatePicker'
import DateSelectorShortcuts from '@/components/report/DateSelectorShortcuts'
import VfAutocomplete from '@/components/shared/VfAutocomplete'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ValidationMixin from '@/components/mixins/ValidationMixin'
import ReportFormMixin from '@/components/report/ReportFormMixin'
import ReportUtils from '@/components/report/ReportUtils'

import { required, requiredIf } from 'vuelidate/lib/validators'

import { map } from 'lodash'

export default {
  name: 'FleetHealthReportForm',
  components: {
    DatePicker,
    DateSelectorShortcuts,
    VfAutocomplete
  },
  mixins: [
    CurrentUserMixin,
    ValidationMixin,
    ReportFormMixin
  ],
  validations: {
    reportCustomers: {
      required
    },
    localReport: {
      name: {
        required: requiredIf(function () {
          return this.action !== 'create'
        })
      }
    },
    dateRange: {
      rangeIsValid: function () {
        return ReportUtils.dateRangeIsValid(this.startDate, this.endDate)
      }
    }
  },
  data () {
    return {
      reportType: 'FleetHealthReport',
      dateKeyed: true,
      startDate: null,
      endDate: null,
      reportCustomers: []
    }
  },
  computed: {
    nameErrors () {
      return this.validationErrors([{
        prop: this.$v.localReport.name,
        message: this.$t('required')
      }])
    },
    customerErrors () {
      return this.validationErrors([{
        prop: this.$v.reportCustomers,
        message: this.$t('customer_required')
      }])
    },
    dateRangeErrors () {
      return this.validationErrors([{
        prop: this.$v.dateRange,
        message: this.$t('invalid_date_range')
      }])
    },
    /**
     * Lists customers available to the current user (customers in their scope)
     */
    availableCustomers () {
      return map(this.customers, customer => {
        return {
          value: customer.id,
          text: customer.name
        }
      })
    }
  },
  methods: {
    defaultReportName () {
      return this.$t('reports_ui.fleet_health_report.name')
    },
    /** Hook to populate report (called from mixin fns) */
    populateReportForm () {
      this.preSelectDates()
      this.preSelectCustomers()
    },
    /** Build report params (called from mixin) */
    buildReportParameters () {
      const reportParameters = {}
      reportParameters.startDate = this.startDate.format('YYYY-MM-DD')
      reportParameters.endDate = this.endDate.format('YYYY-MM-DD')
      reportParameters.customerIds = this.reportCustomers
      return reportParameters
    }
  }
}
</script>

<style scoped>

</style>
